
<template>
    <validation-observer ref="importFormObserver">
        <validation-provider name="certificates_id" rules="required" v-slot="{valid,errors}">
            <b-form-group :label="$t('certificate')">
                <certificate-center-certificate-selectbox v-model="importCertificatesForm.certificates_id" :validateError="errors[0]"/>
            </b-form-group>
            <ValidationProvider name="file" rules="required" v-slot="{ valid, errors }">
                <b-form-group :label="$t('file')">
                    <div class="d-flex custom-file-upload">
                        <b-form-file v-model="importCertificatesForm.file" :accept="'.xlsx,.xls'" :placeholder="$t('select_file')"
                                     ref="fileInput"></b-form-file>
                        <b-button variant="outline-secondary" @click="$refs.fileInput.$el.childNodes[0].click();">{{
                                $t('browse') }}</b-button>
                    </div>
                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                </b-form-group>
            </ValidationProvider>
            <DownloadExcelTemplate :code="'certificate_applications'"/>
            <ProcessingButton :label="$t('save')" :processing="importCertificatesForm.loading" class="mt-2 d-flex justify-center"  @click="importCertificates"/>
        </validation-provider>
    </validation-observer>
</template>
<script>
import DownloadExcelTemplate from "@/components/interactive-fields/DownloadExcelTemplate.vue";
import CertificateCenterCertificateSelectbox from "@/components/interactive-fields/CertificateCenterCertificateSelectbox.vue";

import ProcessingButton from "@/components/elements/ProcessingButton.vue";
import CertificateApplicationService from "@/services/CertificateApplicationService";

export default {
    name: "İmportExcel",
    components: {ProcessingButton, DownloadExcelTemplate,CertificateCenterCertificateSelectbox},
    data(){
        return{
            importCertificatesForm: {
                file: null,
                certificates_id:null,
                loading:false

            },
        }
    },
    methods:{
        async importCertificates(){
            const isValid = await this.$refs.importFormObserver.validate();
            if(!isValid) return;
            try {
                this.importCertificatesForm.loading = true;
                const formData =new FormData()
                formData.append('file',this.importCertificatesForm.file)
                const res =await CertificateApplicationService.importExcel(this.importCertificatesForm.certificates_id,formData);
                this.$router.push('/job/logs/detail/' + res.data.data.log_id)
            }catch (err){
                this.showErrors(err,null,true)
            }finally {
                this.importCertificatesForm.loading=false
            }
        }
    }
}
</script>


<style scoped>

</style>
